import React, { useContext, useEffect, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { useLocation, useNavigate } from 'react-router-dom';
// import PropTypes from 'prop-types';
import recordFileApi from '../apis/recordFileApi';
import LinkContext from '../context/LinkContext';

// MainPage.propTypes = {
    
// };

function MainPage(props) {

    const [audio, setAudio] = useState(null);

    let navigate = useNavigate();

    const location = useLocation();

    // console.log("URL Location: ", location.pathname);

    const currUrl = useContext(LinkContext);

    useEffect(() => {
        const fetchGetAudioFile = async () => {
            try {
                const fileDirPath = location.pathname.substring(9);
                const encodedFDP = btoa(fileDirPath);
                // console.log("Encoded fileDirPath", encodedFDP);

                const response = await recordFileApi.get(encodedFDP);
    
                // console.log("Fetch file successfully: ", response);

                const url = window.URL.createObjectURL(new Blob([response]));

                setAudio(url);

                // console.log("Blob url: ", url);

            } catch (error) {
                console.log("Failed to fetch load file: ", error);
                navigate('/sign-in');
            }
        }

        currUrl.setUrl(location.pathname);
        // console.log("Context url now: ", currUrl.curUrl);

        if(location.pathname.length > 9 && location.pathname.substring(0, 9) === "/records/") {
            fetchGetAudioFile();
        }
        

        // axios({
        //     // url: 'https://danviet.mediacdn.vn/thumb_w/640/296231569849192448/2021/6/2/103152iufull-1622611626053-16226116264121957573404-0-172-768-1401-crop-16226116333461986570645.jpg', //your url
        //     url: 'http://localhost:5000/api/values',
        //     method: 'GET',
        //     responseType: 'blob', // important
        // }).then((response) => {import { useNavigate } from 'react-router-dom';

        //     const url = window.URL.createObjectURL(new Blob([response.data]));

        //     setAudio(url);

        //     // const link = document.createElement('a');
        //     // link.href = url;
        //     // link.setAttribute('download', 'file.jpg'); //or any other extension
        //     // document.body.appendChild(link);
        //     // link.click();
        // });
    }, [currUrl]);    

    return (
        <div>
            {(audio !== null) ?
            <>
            <ReactAudioPlayer
                // src={BASE_URL_API_BE + "/files/chaongaymoi.wav"}
                src={audio}
                autoPlay
                controls
            />
            {/* <br />
            <a href={audio}
                download="audio.wav"
            >
                Download
            </a>  if your browser not support player */}
            </> :
            <h5>Please enter URL with right ID</h5> }
        </div>
    );
}

export default MainPage;